import {useContext} from 'react'

import Context from '@s-ui/react-context'
import IconFacebook from '@adv-mt/mt-svg-icons/lib/Facebook'
import IconInstagram from '@adv-mt/mt-svg-icons/lib/Instagram'
import IconLinkedin from '@adv-mt/mt-svg-icons/lib/Linkedin'
import IconTiktok from '@adv-mt/mt-svg-icons/lib/Tiktok'
import IconXTwitter from '@adv-mt/mt-svg-icons/lib/XTwitter'
import IconYoutube from '@adv-mt/mt-svg-icons/lib/Youtube'

export const SocialMediaLinks = () => {
  const {domain, i18n} = useContext(Context)
  const domainConfig = domain.get('config')
  const SOCIAL_MEDIA_IDS = domainConfig.get('links').SOCIAL_MEDIA_IDS
  const icons = {
    [SOCIAL_MEDIA_IDS.FACEBOOK]: IconFacebook,
    [SOCIAL_MEDIA_IDS.INSTAGRAM]: IconInstagram,
    [SOCIAL_MEDIA_IDS.TIKTOK]: IconTiktok,
    [SOCIAL_MEDIA_IDS.TWITTER]: IconXTwitter,
    [SOCIAL_MEDIA_IDS.YOUTUBE]: IconYoutube,
    [SOCIAL_MEDIA_IDS.LINKEDIN]: IconLinkedin
  }
  const socialMediaLinks = [...domainConfig.get('links').social]

  const appName = domainConfig.get('APP_NAME')

  return (
    <ul className="mt-SharedCorporateFooter-socialMediaContainer">
      {socialMediaLinks.map(socialMedia => {
        const SocialIcon = icons[socialMedia.text]

        return (
          <li className="mt-SharedCorporateFooter-socialMedia">
            <a
              aria-label={i18n.t(`FOOTER.SOCIAL_MEDIA.LINK_ARIA_LABEL_${appName}`, {socialMedia: socialMedia.text})}
              className="mt-SharedCorporateFooter-socialMediaLink"
              key={socialMedia.text}
              href={socialMedia.url}
              target="_blank"
            >
              <SocialIcon aria-hidden role="presentation" />
            </a>
          </li>
        )
      })}
    </ul>
  )
}
